
const LoginCheck = props => {

        let user = localStorage.getItem('user');
        user = JSON.parse(user);
        console.log(user);
        if (user == null){
            return {'loggedIn': false, 'user': user};
        } else {
            return {'loggedIn': true, 'user': user};
        }

};

export default LoginCheck;






// WEBPACK FOOTER //
// ./src/components/shared/LoginCheck.js